import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Card2 from '../components/Card2'
import Loader from "../components/Loader"
import { getData } from '../services/operation'

const DoctorList = () => {
    const { Category } =useParams()
    const [loading,setLoading]=useState(true)
    const [data,setData]=useState([])
    

    const getDoctorsData=async()=>{
        setLoading(true)
        const response=await getData(Category)
        console.log("data received",response)
        setData(response)
        setLoading(false)      
    }

    useEffect(()=>{
        getDoctorsData()
    },[])


  return (
    <div className='w-full min-h-screen bg-blue-300'>
        {
            loading ? (
                <div className='w-full h-screen flex justify-center items-center'>
                    <Loader/>
                </div>
            ) : (
                <div>
                    {
                        data.length ? (     
                            data.map((cardData,index)=>{
                                return(
                                    <Card2 data={cardData} key={index}/>
                                )
                            })
                    
                        ) : (
                            <div className='text-3xl w-full h-screen flex justify-center items-center text-bold'>
                                No doctors found at the moment
                            </div>
                        )
                    }
                </div>
            )
        }
    </div>
  )
}

export default DoctorList